import { Card } from '../../../components/ui/card';

const inr = n => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;

export const CnByTrainer = ({ rows }) => (
  <Card className="p-4" data-testid="cn-by-trainer">
    <h3 className="text-sm font-bold text-slate-900">Trainer performance — Training Concern credit notes</h3>
    <p className="text-[11px] text-slate-500 mb-3">Avg response = time from case assigned to the trainer's first response.</p>
    <table className="w-full text-xs">
      <thead className="text-[10px] uppercase tracking-wider text-slate-400"><tr>
        <th className="text-left py-1">Trainer</th><th className="text-right">Cases</th><th className="text-right">Value</th><th className="text-right">Awaiting response</th>
        <th className="text-right">Responded</th><th className="text-right">Accountable</th><th className="text-right">Not trainer's fault</th><th className="text-right">Avg response</th></tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={8} className="text-center py-8 text-slate-400">No Training Concern credit notes yet.</td></tr>}
        {rows.map(r => (
          <tr key={r.trainer} className="border-t border-slate-100" data-testid={`cn-trainer-${r.trainer.replace(/[^a-zA-Z0-9]/g, '-')}`}>
            <td className="py-2 font-medium">{r.trainer}</td><td className="text-right font-bold">{r.cases}</td><td className="text-right">{inr(r.amount)}</td>
            <td className={`text-right ${r.pending ? 'text-amber-700 font-semibold' : ''}`}>{r.pending}</td><td className="text-right">{r.responded}</td>
            <td className={`text-right ${r.accountable ? 'text-rose-600 font-semibold' : ''}`}>{r.accountable}</td><td className="text-right text-emerald-700">{r.not_fault}</td>
            <td className="text-right">{r.avg_response_hours == null ? '—' : r.avg_response_hours < 1 ? `${Math.max(1, Math.round(r.avg_response_hours * 60))} min` : `${r.avg_response_hours} h`}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </Card>
);
